import HSKeyValue from './hs-key-value';

export default HSKeyValue;
